import {State} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {AdvertiserBillingService} from '../../services-advertiser/billing/billing.service';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {NgxsDataRepository} from "@angular-ru/ngxs/repositories";
import {StateRepository} from "@angular-ru/ngxs/decorators";
import {DataActionWithoutSubscription} from "@shared/functions";

interface AdvertiserBillingBalanceModel {
  balance: number;
}

@StateRepository()
@State<AdvertiserBillingBalanceModel>({
  name: 'advertiserBillingBalanceState',
  defaults: {
    balance: 0
  }
})

@Injectable()
export class AdvertiserBillingBalanceState extends NgxsDataRepository<AdvertiserBillingBalanceModel> {
  constructor(private billingService: AdvertiserBillingService) {
    super();
  }

  @DataActionWithoutSubscription()
  getBalance(): Observable<number> {
    return this.billingService.getAdvertiserBalance().pipe(
      tap((balance) => {
        const state = this.ctx.getState();
        this.ctx.setState({...state, balance});
      })
    );
  }
}
